import {type FC, memo} from "react";

import {GridDotsIcon} from "../../react";
import {Pressable} from "../ui/pressable";

type Props = {
    testID?: string;
    iconColor?: "white" | "blueGray.400";
    iconSize?: "sm" | "xs";
    className?: string;
};

const DragHandle: FC<Props> = ({
    iconColor = "blueGray.400",
    iconSize,
    className,
    testID = "drag-handle"
}) => {
    return (
        <Pressable className={className} testID={testID}>
            <GridDotsIcon fill={iconColor} size={iconSize} />
        </Pressable>
    );
};

export default memo(DragHandle);
